import { useQuery } from '@tanstack/react-query'

import { getLeadCount } from '../functions'

export function useLeadCount() {
  return useQuery(['userLeadCount'], getLeadCount)
}
